export default __webpack_public_path__ + "static/media/appium.7d894198.svg";